import { render, staticRenderFns } from "./tendency.vue?vue&type=template&id=4ec002d0"
import script from "./tendency.vue?vue&type=script&lang=js"
export * from "./tendency.vue?vue&type=script&lang=js"
import style0 from "./tendency.vue?vue&type=style&index=0&id=4ec002d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports